<template>
  <div class="page-listings">
   <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">My Listings</h1>
    <div v-if="loading" class="row">
      <div class="col">
        <br />Loading... Please Wait...
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <b-table class="mt-3" striped hover :items="items" :fields="fields">
          <template v-slot:cell(Name)="data">
            <router-link :to="`/listing/${data.item.Id}`">{{ data.item.Name }}</router-link>
          </template>
          <template v-slot:cell(actions)="data">
            <!--- <router-link :to="`/listing/${data.item.Id}/stats`" style="margin-right: 10px;"><b-icon-bar-chart /> Stats</router-link>
            <span v-if="data.item.canEdit">&nbsp; | &nbsp;</span> -->
            <router-link v-if="data.item.canEdit" :to="`/listing/${data.item.Id}`" style="margin-left: 10px;"><b-icon-pencil /> Edit</router-link>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Listings',
  data() {
    return {
      loading: true,
      test: 'test',
      items: [],
      fields: [
        {
          key: 'Name',
          label: 'Listing Name',
          sortable: true,
        },
        { key: 'actions', label: '' },
      ],
    };
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawListings = await axios.get(`${server}/api/listings`);
        if (rawListings.data.redirect) {
          window.location.href = rawListings.data.redirect;
          return;
        }
        const listings = rawListings.data;
        this.items = listings.map((l) => ({ Id: l.Account.Id, Name: l.Account.Name, canEdit: l.Roles !== 'State Exec' }));
        this.loading = false;
      } catch (err) {
        console.log({ listListingsError: err });
      }
    });
  },
};
</script>
